// extracted by mini-css-extract-plugin
export default {"PageContainer":"FollowPage_PageContainer__sqlPY","ContentContainer":"FollowPage_ContentContainer__K3U1o","TeamList":"FollowPage_TeamList__jAHov"};